<template>
  <span class="el-table-emptyImg">
    <img :src="src" alt="" class="empty">
    <span class="no-data">暂无数据</span>
  </span>
</template>

<script>

export default {
  name: 'EmptyBox',
  props: {
    src: {
      type: String,
      default: 'https://sitecdn.71360.com/static/t-tyui/empty.png'
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.el-table-emptyImg .empty {
  width: 150px;
  height: 150px;
  margin-top: 80px;
  margin-bottom: 0px;
}
</style>
